import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Form } from 'semantic-ui-react'
import forOwn from 'lodash/forOwn'
import moment from 'moment'

import { withUserConfig, withSystemConfig } from 'shared'
// @ts-ignore
import withLivedata from 'shared/containers/withLivedata'
import { withConstantPermissions } from 'shared'

import { convertUnicodeToLatin } from '../../../store/utility'
import containerForm, { formChangeContainer } from '../clientsContainerForm'
import clientsContainer from '../clientsContainer'
import { FirstPage, SecondPage, ThirdPage, FourthPage, FifthPage, SixthPage } from './Pages'
import { initialValues } from './constants'
import { loadCitiesByCountryId } from '../../../store/lookups'
import { actionTypes } from '../constants'

const StyledForm = styled(Form)`
  height: 100%;
`

// @ts-ignore
@withConstantPermissions()
@withLivedata(['OpenDayStatus.Open_Day_Str as OpenDayStr', 'OpenDayStatus.Cur_Date as CurrentDay'])
@withSystemConfig(['AgeLimitMax', 'AgeLimitMin', 'CellPhoneValidate'])
// @ts-ignore
@withUserConfig()
// @ts-ignore
@clientsContainer
// @ts-ignore
@containerForm
// @ts-ignore
@formChangeContainer
// @ts-ignore
@connect(undefined, {
  convertUnicodeToLatin,
  loadCitiesByCountryId,
})
class PhysicalClientForm extends React.PureComponent<any> {
  cachedCities = new Map<string, Array<any>>()
  state = {
    CRAImage: '/static/images/no-camera.svg',
  }

  componentDidMount() {
    const defaultValues = {}

    const [IDCardtype] = this.props.selects.IDCardtype || []

    forOwn(this.props.fields, ({ FName, DefValue }) => {
      this.props.registerFormField(FName)

      Object.keys(initialValues)
        .filter((key) => ['CountryID', 'Country2ID', 'CountryBusID'].includes(key))
        .forEach((key) => {
          initialValues[key] = this.props.config.MyCountryID
        })

      if (['CityBusID', 'CityID', 'City2ID'].includes(FName)) {
        const { cities } = this.props
        defaultValues[FName] = cities[0].ID
      } else if (FName === 'CitizenshipID' && IDCardtype) {
        defaultValues[FName] = IDCardtype.DFCitizID
      } else if (FName === 'IND_Resident' && IDCardtype) {
        defaultValues[FName] = IDCardtype.DFResidID
      } else if (DefValue) {
        defaultValues[FName] = Number.isInteger(initialValues[FName]) ? parseFloat(DefValue) : DefValue
      }
    })

    this.props.dynamicFields.forEach((df) => this.props.registerFormField(`DynFieldData.${df.FieldName}`))
    this.props.registerFormField('CellPhoneValidateCode')

    if (!this.props.editting) {
      const {
        config: { NodeID },
        OpenDay,
        dynamicFields,
      } = this.props

      const allInitialValues = {
        ...initialValues,
        ...defaultValues,
        IND_DOB: OpenDay,
        IDCardRegDate: OpenDay,
        IDValidityDate: moment().format('DD.MM.YYYY'),
        NodeID,
      } as Record<string, any>

      if (this.props.params.regfee !== undefined) {
        allInitialValues.RegFee = this.props.params.regfee
      }

      const finalInitialValues = dynamicFields.reduce((result, current) => {
        let defValue = current.DefaultValue

        if (current.FieldDataType === 0) {
          if (!defValue) defValue = 1
          defValue = parseInt(defValue, 10)
        }

        if (current.FieldDataType === 8) {
          const parentSelect = dynamicFields.find((dynamicField) => dynamicField.ID === current.ParentFieldID)
          const filteredOptions =
            parentSelect && current.LookupData.filter((cur) => cur.ParentID === parseInt(parentSelect.DefaultValue, 10))

          defValue = filteredOptions && filteredOptions[0] ? filteredOptions[0].ID : 1
        }

        if (current.FieldDataType === 5 && current.DefaultValue === '01.01.1900') {
          defValue = ''
        }

        return {
          ...result,
          DynFieldData: {
            ...result.DynFieldData,
            [current.FieldName]: defValue,
          },
        }
      }, allInitialValues)

      // Redux form initialize method passed from reduxForm
      this.props.initialize(finalInitialValues)
    }
  }

  handleChangeCRAImage = (base64, callback) => {
    this.setState({ CRAImage: `data:image/png;base64, ${base64}` }, callback)
  }

  onTranslateAltRequest = (target) => async (event) => {
    const { value } = event.target

    if (!value) {
      this.props.changeFormValue(target, '')
      return
    }

    const result = await this.props.convertUnicodeToLatin(value)
    if (convertUnicodeToLatin.fulfilled.match(result)) {
      this.props.changeFormValue(target, result.payload)
    }
  }

  onCountryChange = async (value: string | number, fieldName: string) => {
    let cities
    const cachedKey = `${fieldName}_${value}`

    if (this.cachedCities.has(cachedKey)) {
      cities = this.cachedCities.get(cachedKey)
    } else {
      const {
        payload: { lookups: data },
      } = await this.props.loadCitiesByCountryId(value)
      cities = data

      this.cachedCities.set(cachedKey, data)
    }

    this.props.dispatch({ type: actionTypes.UPDATE_CITIES_LIST, payload: { cities, fieldName } })

    if (cities) {
      const [firstCity] = cities
      this.props.changeFormValue(fieldName, firstCity.ID)
    }
  }

  renderProperSection() {
    const {
      fields,
      selects,
      dynamicOptions,
      dynamicFields,
      dynamicFieldsDynamicOptions,
      noVisibilityFilter,
      actionType,
      permissions,
      params,
      changeFormValue,
      activeSection,
      cityList,
      showThirdPage,
      showFourthPage,
      showFifthPage,
      showSixthPage,
    } = this.props

    const pages = {
      FirstPage: (
        <FirstPage
          noVisibilityFilter={noVisibilityFilter}
          dynamicOptions={dynamicOptions}
          fields={fields}
          selects={selects}
          onTranslateAltRequest={this.onTranslateAltRequest}
          actionType={actionType}
          permissions={permissions}
          CRAImage={this.state.CRAImage}
          onChangeCRAImage={this.handleChangeCRAImage}
          changeFormValue={changeFormValue}
        />
      ),
      SecondPage: (
        <SecondPage
          noVisibilityFilter={noVisibilityFilter}
          dynamicOptions={dynamicOptions}
          fields={fields}
          selects={selects}
          cityList={cityList}
          onTranslateAltRequest={this.onTranslateAltRequest}
          onCountryChange={this.onCountryChange}
          actionType={actionType}
          permissions={permissions}
          params={params}
          changeFormValue={changeFormValue}
        />
      ),
      ThirdPage: <ThirdPage noVisibilityFilter={noVisibilityFilter} fields={fields} selects={selects} />,
      FourthPage: (
        <FourthPage dynamicFieldsDynamicOptions={dynamicFieldsDynamicOptions} dynamicFields={dynamicFields} />
      ),
      FifthPage: <FifthPage fields={fields} />,
      SixthPage: <SixthPage fields={fields} />,
    }

    const PagesArray = [pages.FirstPage, pages.SecondPage]

    if (showThirdPage) {
      PagesArray.push(pages.ThirdPage)
    }

    if (showFourthPage) {
      PagesArray.push(pages.FourthPage)
    }

    if (showFifthPage) {
      PagesArray.push(pages.FifthPage)
    }

    if (showSixthPage) {
      PagesArray.push(pages.SixthPage)
    }

    return PagesArray[activeSection - 1]

    // switch (activeSection) {
    //   case 1:
    //     return PagesArray[0];

    //   case 2:
    //     return PagesArray[1]

    //   case 3:
    //     return PagesArray[2]

    //   case 4:
    //     return pages.FourthPage

    //   case 5:
    //     return pages.FifthPage

    //   case 6:
    //     return pages.SixthPage

    //   default:
    //     return null
    // }
  }

  render() {
    const { handleSubmit } = this.props

    return <StyledForm onSubmit={handleSubmit}>{this.renderProperSection()}</StyledForm>
  }
}

export default PhysicalClientForm
